import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import React from "react";
import { twMerge } from "tailwind-merge";

import { Small } from "@fronterahealth/frontera-ui-components";

import { useFieldReview } from "@components/QaReview/hooks/useFieldReview";

export interface SuggestionIndicatorProps {
  /** The field ID for the suggestion indicator */
  fieldId: string;
  /** Number of suggestions to display */
  suggestionCount: number;
  /** Optional additional class names */
  className?: string;
}

export const SuggestionIndicator: React.FC<SuggestionIndicatorProps> = ({
  fieldId,
  suggestionCount,
  className = "",
}) => {
  const { isActive, activate } = useFieldReview();

  return (
    <div
      data-suggestion-indicator={fieldId}
      className={twMerge(
        "flex flex-row gap-1 cursor-pointer items-center justify-center z-10 pr-1 rounded-sm",
        isActive(fieldId) ? "bg-limestone-50" : "",
        className,
      )}
      onClick={() => activate(fieldId)}
    >
      <ExclamationTriangleIcon className="h-6 w-6 p-1 text-yellow-600 cursor-pointer" />
      <Small className="cursor-pointer">{suggestionCount}</Small>
    </div>
  );
};
